export const runTerminalCleared = ({
	dashboard,
	payload,
	setDashboard,
}) => {
	if (!payload || !Array.isArray(dashboard?.widgets) || typeof setDashboard !== 'function') {
		return;
	}

	let hasUpdates = false;
	const payloadWidgetId = String(payload.widgetId || '');
	const payloadDeviceId = payload.deviceId == null || payload.deviceId === ''
		? null
		: Number(payload.deviceId);
	const payloadDataId = payload.dataId == null || payload.dataId === ''
		? null
		: Number(payload.dataId);

	const updatedWidgets = dashboard.widgets.map((widget) => {
		if (widget?.type !== 'terminal') {
			return widget;
		}

		const widgetId = String(widget.id || '');
		const widgetDeviceId = widget.device_id == null || widget.device_id === ''
			? null
			: Number(widget.device_id);
		const widgetDataId = widget.data_id == null || widget.data_id === ''
			? null
			: Number(widget.data_id);

		const matchesWidgetId = widgetId && payloadWidgetId && widgetId === payloadWidgetId;
		const matchesDeviceAndData =
			Number.isFinite(widgetDeviceId) &&
			Number.isFinite(payloadDeviceId) &&
			Number.isFinite(widgetDataId) &&
			Number.isFinite(payloadDataId) &&
			widgetDeviceId === payloadDeviceId &&
			widgetDataId === payloadDataId;
		const matchesDataOnly =
			!Number.isFinite(widgetDeviceId) &&
			!Number.isFinite(payloadDeviceId) &&
			Number.isFinite(widgetDataId) &&
			Number.isFinite(payloadDataId) &&
			widgetDataId === payloadDataId;

		if (!matchesWidgetId && !matchesDeviceAndData && !matchesDataOnly) {
			return widget;
		}

		const preservedLastLiveValue =
			widget?.extra_props?.__lastLiveValue == null
				? null
				: String(widget.extra_props.__lastLiveValue);

		hasUpdates = true;
		return {
			...widget,
			extra_props: {
				...widget.extra_props,
				value: '',
				__lastLiveValue: preservedLastLiveValue,
			},
		};
	});

	if (!hasUpdates) {
		return;
	}

	setDashboard({
		...dashboard,
		widgets: updatedWidgets,
	});
};
